import { Card, Col, Flex, Row, Tag, Typography } from 'antd';
import type {
  InternshipApplication,
  ReducedInternship,
} from '../../Types/interfaces';
import { ImageLoader } from '../InternshipList/ImageLoader';
import { useReducedOrganizationById } from '../../hooks/useOrganizations';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

interface InternshipOfferAppliedComponentProps {
  internshipOffer: ReducedInternship;
  studentApplication: InternshipApplication | undefined;
  organizationId: string | number;
}

export const InternshipOfferAppliedComponent = ({
  internshipOffer,
  studentApplication,
  organizationId,
}: InternshipOfferAppliedComponentProps) => {
  const { data: reducedOrganization } =
    useReducedOrganizationById(organizationId);
  const { t } = useTranslation();

  const renderStatus = (
    internshipOfferStatus: number | undefined
  ): React.ReactNode => {
    switch (internshipOfferStatus) {
      case 0:
        return (
          <Tag color="blue">{t('internshipProcessComp.processStatus')}</Tag>
        );
      case 1:
        return (
          <Tag color="green">
            {t('internshipApplicationComp.acceptedStatus')}
          </Tag>
        );
      case 2:
        return (
          <Tag color="red">{t('internshipOfferAppliedComp.rejected')}</Tag>
        );
    }
  };

  return (
    <Card
      style={{
        width: 500,
        height: 230,
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      }}
    >
      <Flex gap="large" align="start">
        {/* Organization logo */}
        <div
          style={{
            flexShrink: 0,
          }}
        >
          <ImageLoader
            style={{
              width: '100px',
              height: '100px',
              objectFit: 'contain',
              objectPosition: 'top left',
            }}
            logoData={internshipOffer.logoData}
          />
        </div>

        {/* Right side with organization name and internship title */}
        <Flex vertical gap="small">
          <Title
            level={5}
            style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}
          >
            {reducedOrganization?.name}
          </Title>
        </Flex>
      </Flex>

      <Flex justify="space-between">
        <Flex vertical gap={4} style={{ marginTop: '4px', width: '100%' }}>
          <Row justify="space-between">
            <Col span={5}>
              <Text strong>{t('internshipOfferAppliedComp.position')}</Text>
            </Col>
            <Col span={19}>
              <Text>{internshipOffer.name}</Text>
            </Col>
          </Row>

          <Row justify="space-between">
            <Col span={5}>
              <Text strong>{t('internshipOfferAppliedComp.status')}</Text>
            </Col>
            <Col span={19}>{renderStatus(studentApplication?.status)}</Col>
          </Row>
        </Flex>
      </Flex>
    </Card>
  );
};
